import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./components/Navbar";
import BackgroundController from "./components/BackgroundController";
import VersionFooter from "./components/VersionFooter";

// Pages
import Main from "./pages/Main";
import Media from "./pages/media/Media";
import Twitch from "./pages/media/Twitch";
import YouTube from "./pages/media/YouTube";
import TikTok from "./pages/media/TikTok";
import Apply from "./pages/Apply";
import CodeOfConduct from "./pages/CodeOfConduct";
import Fleet from "./pages/Fleet";
import Blog from "./pages/Blog";
import NotFound from "./pages/NotFound";
// Organisation scraping is handled within the portal service.

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

function AnalyticsPageView() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const frame = window.requestAnimationFrame(() => {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: pathname + search,
      });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, search]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsPageView />
      <BackgroundController />
      <motion.a
        href="https://robertsspaceindustries.com/en/comm-link/transmission/21082-Tactical-Strike-Groups-Org-Spotlight"
        target="_blank"
        rel="noopener noreferrer"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
        className="block w-full bg-black text-white text-center px-4 py-2 sm:py-3 text-base sm:text-lg md:text-xl font-bebas tracking-wider uppercase hover:text-[#96000b] transition-colors duration-300 ring-1 ring-[#96000b]/40 shadow-[0_0_20px_rgba(150,0,11,0.5)]"
      >
        Cloud Imperium Games featured us in the{" "}
        <span className="text-[#96000b]">Tactical Strike Groups Org Spotlight</span>!{" "}
        <motion.span
          animate={{ x: [0, 6, 0] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
          className="inline-block"
        >
          &rarr;
        </motion.span>
      </motion.a>
      <Navbar />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/media/Media" element={<Media />} />
        <Route path="/media/Twitch" element={<Twitch />} />
        <Route path="/media/youtube" element={<YouTube />} />
        <Route path="/media/tiktok" element={<TikTok />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/code-of-conduct" element={<CodeOfConduct />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <VersionFooter />
    </Router>
  );
}

export default App;
